import {
  Filter,
  FILTER_FIELD,
  FilterCondition,
  FilterNode,
} from '@adtrackify/at-tracking-event-types';

const isCondition = (node: FilterNode): node is FilterCondition =>
  'field' in node && 'op' in node;

export function findConditionByField(
  filters: Filter | undefined,
  field: FILTER_FIELD,
): FilterCondition | undefined {
  if (!filters || !('and' in filters) || !filters.and) return undefined;
  const match = filters.and.find(child => isCondition(child) && child.field === field);
  return match as FilterCondition | undefined;
}

export function upsertConditionByField(
  filters: Filter | undefined,
  field: FILTER_FIELD,
  condition: FilterCondition,
): Filter {
  const existing = filters && 'and' in filters && filters.and ? filters.and : [];
  const existingIndex = existing.findIndex(
    child => isCondition(child) && child.field === field,
  );
  const nextChildren = [...existing];
  if (existingIndex >= 0) {
    nextChildren[existingIndex] = condition;
  } else {
    nextChildren.push(condition);
  }
  return { and: nextChildren };
}

export function removeConditionByField(
  filters: Filter | undefined,
  field: FILTER_FIELD,
): Filter | undefined {
  if (!filters || !('and' in filters) || !filters.and?.length) return undefined;
  const nextChildren = filters.and.filter(
    child => !(isCondition(child) && child.field === field),
  );
  if (!nextChildren.length) return undefined;
  return { and: nextChildren };
}
